export default "__VITE_ASSET__S8GkA_tb__"